export const isAbsoluteHttpUrl = (x: string): boolean => /^https?:\/\/.+/.test(x);

/**
 * Obtain URL object. This has no different from calling new URL constructor
 * @param url
 * @param baseUrl
 */
export const toUrl = (url: string, baseUrl?: string): URL => new URL(url, baseUrl);
export const resolveUrl = (url: string, baseUrl?: string): string => toUrl(url, baseUrl).href;

export const isAnchorLink = (target: string): boolean => target.startsWith('#');

/**
 * Extract the origin of a given URL.
 *
 * If a partial URL is provided, the method will assume its base origin to be the same as current document's origin
 * This method will return null if it cannot construct a valid URL using the given parameters. This scenario might happen if the provided documentOrigin is invalid.
 *
 * @param urlString
 * @param documentOrigin
 * @return origin of the given urlString in lowercase
 */
export const getOrigin = (urlString: string, documentOrigin = location.origin): string | null => {
  if (isAnchorLink(urlString)) return documentOrigin;
  if (urlString.startsWith('/')) return documentOrigin;

  try {
    const url = toUrl(urlString, documentOrigin);
    return url.origin;
  } catch (error) {
    return null;
  }
};

/**
 * Return true if the given url is an internal url
 *
 * An internal URL:
 * - a URL that shares the same origin with current document.
 * - Partial URL such as absolute path, relative path, hash fragment are considered as internal URL
 * - URL with different protocol or port is not considered as an internal URL
 *
 * @param target
 */
export const isInternalUrl = (urlString: string): boolean => {
  const origin = getOrigin(urlString);
  return location.origin === origin;
};
